module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "src": _vm.shibLogoutUrl,
      "width": "0px",
      "height": "0px",
      "scrolling": "no"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-panel-body"
  }, [_c('h2', [_vm._v("Kijelentkezés")]), _vm._v(" "), _c('p', [_vm._v("Ön sikeresen kijelentkezett rendszerükből.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        path: '/login'
      }
    }
  }, [_vm._v("Szeretnék újra bejelentkezni")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-panel-head"
  }, [_c('h1', [_c('i', {
    staticClass: "kricon fa fa-id-card-o"
  }), _c('h1', [_vm._v("KMR"), _c('span', [_vm._v(" - Kártya menedzsment rendszer")])])]), _vm._v(" "), _c('p', [_vm._v("A Széchenyi István Egyetem kártya menedzsment felülete.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3da0831d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/logout.vue
// module id = 52
// module chunks = 0